import type { TaskStatus } from "@/modules/management/project/domain/types";
import { cn } from "@devhop/ui";
import { taskStatusProgressFillClass } from "../lib/task-status-progress-styles";

type TaskProgressBarProps = {
  status: TaskStatus;
  value: number;
  className?: string;
  "aria-label"?: string;
};

export function TaskProgressBar({
  status,
  value,
  className,
  "aria-label": ariaLabel,
}: TaskProgressBarProps) {
  const pct = Math.min(100, Math.max(0, value));
  const fill = taskStatusProgressFillClass(status);
  return (
    <div
      className={cn("h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel ?? `ຄວາມຄືບໜ້າ ${pct}%`}
    >
      <div
        className={cn(
          "h-full rounded-full transition-[width] duration-200",
          fill,
        )}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
